import React from 'react';
import { createStyles, makeStyles } from '@material-ui/core';
import { monolithEmbeddedStarts, monolithEmbeddedStartsM, monolithLStarts, monolithMStart, } from './EmbeddedSignUpTypes';
var useStyles = makeStyles(function (_a) {
    var _b, _c, _d;
    var spacing = _a.spacing, typography = _a.typography, palette = _a.palette;
    return createStyles({
        terms: {
            fontFamily: typography.fontFamily,
            fontSize: typography.caption.fontSize,
            color: palette.border.main,
            textAlign: function (_a) {
                var hideCaptchaTerms = _a.hideCaptchaTerms;
                return (hideCaptchaTerms ? 'center' : 'start');
            },
            '& a': (_b = {
                    display: 'inline',
                    fontWeight: typography.fontWeightBold,
                    fontSize: spacing(1.5),
                    textDecoration: 'none',
                    color: palette.secondary.main,
                    '&:hover': {
                        textDecoration: 'underline',
                    }
                },
                _b["@media (min-width:" + monolithMStart + "px)"] = {
                    display: 'inline-block',
                },
                _b["@media (min-width:" + monolithEmbeddedStarts + "px)"] = {
                    display: 'inline',
                },
                _b["@media (min-width:" + monolithLStarts + "px)"] = {
                    display: 'inline-block',
                },
                _b),
        },
        terms_loh: {
            fontFamily: typography.fontFamily,
            fontSize: typography.caption.fontSize,
            color: palette.border.disabled,
            textAlign: function (_a) {
                var hideCaptchaTerms = _a.hideCaptchaTerms;
                return (hideCaptchaTerms ? 'center' : 'start');
            },
            '& p': (_c = {},
                _c["@media (min-width:" + monolithEmbeddedStartsM + "px)"] = {
                    minWidth: 262,
                },
                _c["@media (min-width:" + monolithLStarts + "px)"] = {
                    minWidth: 298,
                },
                _c),
            '& a': (_d = {
                    display: 'inline',
                    fontWeight: typography.fontWeightBold,
                    fontSize: spacing(1.5),
                    textDecoration: 'none',
                    color: palette.border.disabled,
                    '&:hover': {
                        textDecoration: 'underline',
                    }
                },
                _d["@media (min-width:" + monolithMStart + "px)"] = {
                    display: 'inline-block',
                },
                _d["@media (min-width:" + monolithEmbeddedStarts + "px)"] = {
                    display: 'inline',
                },
                _d["@media (min-width:" + monolithLStarts + "px)"] = {
                    display: 'inline-block',
                },
                _d),
        },
    });
});
export function SignUpTerms(props) {
    var _a = props.hideCaptchaTerms, hideCaptchaTerms = _a === void 0 ? false : _a, _b = props.isLoggedOutHome, isLoggedOutHome = _b === void 0 ? false : _b;
    var classes = useStyles(props);
    return (React.createElement("p", { className: isLoggedOutHome ? classes.terms_loh : classes.terms },
        "By signing up you agree to Skillshare's\u00A0",
        isLoggedOutHome ? React.createElement("br", null) : '',
        React.createElement("a", { target: "_blank", href: "/terms" }, "Terms of Service"),
        "\u00A0and\u00A0",
        React.createElement("a", { target: "_blank", href: "/privacy" }, "Privacy Policy."),
        !hideCaptchaTerms && (React.createElement(React.Fragment, null,
            "\u00A0This page is protected by reCAPTCHA and is subject to Google's\u00A0",
            React.createElement("a", { target: "_blank", rel: "noreferrer", href: "https://policies.google.com/terms" }, "Terms of Service"),
            "\u00A0and\u00A0",
            React.createElement("a", { target: "_blank", rel: "noreferrer", href: "https://policies.google.com/privacy" }, "Privacy Policy.")))));
}
//# sourceMappingURL=SignUpTerms.js.map